<div class="chart-holder">
  <cs-card-title>
    {{ title }}
    @if (tooltipInfo) {
    <cs-tooltip [text]="tooltipInfo"></cs-tooltip>
    }
    @if (seeAllClick.observed) {
    <cs-button tertiary (click)="onSeeAllClick()">{{ LL.trendChart.seeAll()
      }}</cs-button>
    }
    <cs-note>{{ LL.trendChart.last7Days() }}</cs-note>
  </cs-card-title>

  <div #canvasHolder class="canvas-holder">
    <canvas #chartCanvas></canvas>
    @if (isEmpty) {
    <div class="no-data-watermark">{{ LL.trendChart.noData() }}</div>
    }
  </div>
  @if (loading) {
  <div class="content-spinner">
    <cs-spinner></cs-spinner>
  </div>
  }
  @if (!loading) {
  <cs-label class="chart-footer" no-margin>
    @if (currentValue || datasetsGains.length > 0) {
    <div class="current-stat">
      @if (currentValue) {
      <div class="stat-value">
        {{ currentValue }}
      </div>&nbsp;
      <div class="stat-unit">
        {{ unit }}
      </div>
      } @else {
      @if (chartType === 'line') {
      --
      }
      }
      <div class="stat-gains">
        @for (gain of datasetsGains; track gain; let iGain = $index) {
        <div class="stat-gain"
          [ngClass]="{'acceptable': (chartType === 'bar' ? iGain === 0 : (positiveIsGood ? gain > 0 : gain <= 0))}">
          <cs-icon [name]="(chartType === 'bar' ? iGain === 0 : gain >= 0) ? 'arrow-up' : 'arrow-down'">
          </cs-icon>
          <div class="stat-gain-value">
            {{ gain }}
          </div>
        </div>
        }
      </div>
    </div>
    } @else {
    @if (chartType === 'line') {
    --
    }
    }
  </cs-label>
  }
</div>